// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"ffda3c7b800f45212277","678":"07481b1df381e480d2fc","774":"402753e848e1898fe312","883":"4231817c271c705894b3"}[chunkId] + ".js";
};